module.exports = __webpack_public_path__ + "img/open24-7.ee542347.png";